// extracted by mini-css-extract-plugin
export default {"expenses-expenseList":"ExpenseList_expenses-expenseList__79saF"};